import axiosInstance from '@/config/http.config'

// Ambos reportes se generan en el backend como un Excel (.xlsx) — por eso se
// pide con responseType: 'blob', para poder descargarlo tal cual llega.

export function getApprovedReport(plantId, { from, to }) {
  return axiosInstance.post(
    `/reports/approved/${plantId}`,
    { from, to },
    { responseType: 'blob' }
  )
}

export function getDisapprovedReport(plantId, { from, to }) {
  return axiosInstance.post(
    `/reports/disapproved/${plantId}`,
    { from, to },
    { responseType: 'blob' }
  )
}
